        // Daily Notices //
		if ($('.daily-wrapper').length > 0) {
            $.ajax({

                url: "https://eduapp.com.au/api/v3/notices.jsonp?api_token=8aa8caeba98f5a6ee9d44c0e4ec6da09950dace3",
                dataType: "jsonp",
                type: "GET",
                success: function(response) {

                    $(".notice-main-title").show();

                    $.each(response, function(index, notice) {

                        // get clone
                        var clone = $('.daily-clone').find(":first").clone(true);
                        clone.find('.notices-title').text(notice.title);

                        var body_text = notice.body;
                        body_text = body_text.replace("â€™", "'");

                        clone.find('.notices-body').text(body_text);
                        clone.find('.notices-title').attr('href', '#' + notice.id);
                        clone.find('.notice-content').attr('id', notice.id);

                        // clone.find('.notices-title').click(function() {

                        //     if ($(this).parent().find('.notice-content').css('display') == "block"){
                        //         $(this).parent().find('.notice-content').slideUp();
                        //     } else {
                        //         $(this).parent().find('.notice-content').slideDown();
                        //     }

                        // })

                        var attachment_container = clone.find('.attachments');

                        var attachments = notice.attachments;

                        attachment_container.html('');

                        if (notice.attachments.length > 0) {

                            attachment_container.append('<br><h4>Attachments</h4>');

                        }

                        $.each(attachments, function(index, attachment) {

                            var title = "";

                            if (attachment.type == "link") {

                                title = "Link";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr({href: attachment.url, target: '_blank'}).text(attachment.url);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "file") {
                                
                                title = "File";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr('href', attachment.url).text(attachment.file_name);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "address") {
                                    
                                title = "Address";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<span>').text(attachment.address);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "contact") {
                                
                                title = "Contact";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                            
                                var name = $('<span>').text(attachment.contact_name);
                                var phone = $('<span>').text(attachment.contact_phone);
                                var email = $('<span>').text(attachment.contact_email);

                                attachment_container.append(name);
                                attachment_container.append(phone);
                                attachment_container.append(email);

                            }

                            attachment_container.append('<br>')

                        });
                        attachment_container.append('<br>')

                        // append clone to wrapper
                        $('.daily-wrapper').append(clone);

                    });

                },
                error: function(err) {

                }

            });
        }
        // Sports Notices //
        if ($('.sports-wrapper').length > 0) {
            $.ajax({

                url: "https://eduapp.com.au/api/v3/notices.jsonp?api_token=8aa8caeba98f5a6ee9d44c0e4ec6da09950dace3&tag_group_ids[]=121",
                dataType: "jsonp",
                type: "GET",
                success: function(response) {

                    $(".notice-main-title").show();

                    $.each(response, function(index, notice) {

                        // get clone
                        var clone = $('.sports-clone').find(":first").clone(true);
                        console.log(clone);
                        clone.find('.notices-title').text(notice.title);

                        var body_text = notice.body;
                        body_text = body_text.replace("â€™", "'");

                        clone.find('.notices-body').text(body_text);
                        clone.find('.notices-title').attr('href', '#' + notice.id);
                        clone.find('.notice-content').attr('id', notice.id);
                        clone.find('.notices-title').attr('href', '#' + notice.id);
                        clone.find('.notice-content').attr('id', notice.id);

                        // clone.find('.notices-title').click(function() {

                        //     // if ($(this).parent().find('.notice-content').css('display') == "block"){
                        //     //     $(this).parent().find('.notice-content').slideUp();
                        //     // } else {
                        //     //     $(this).parent().find('.notice-content').slideDown();
                        //     // }

                        // })

                        var attachment_container = clone.find('.attachments');

                        var attachments = notice.attachments;

                        attachment_container.html('');

                        if (notice.attachments.length > 0) {

                            attachment_container.append('<br><h4>Attachments</h4>');

                        }

                        $.each(attachments, function(index, attachment) {

                            var title = "";

                            if (attachment.type == "link") {

                                title = "Link";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr({href: attachment.url, target: '_blank'}).text(attachment.url);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "file") {
                                
                                title = "File";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr('href', attachment.url).text(attachment.file_name);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "address") {
                                    
                                title = "Address";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<span>').text(attachment.address);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "contact") {
                                
                                title = "Contact";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                            
                                var name = $('<span>').text(attachment.contact_name);
                                var phone = $('<span>').text(attachment.contact_phone);
                                var email = $('<span>').text(attachment.contact_email);

                                attachment_container.append(name);
                                attachment_container.append(phone);
                                attachment_container.append(email);

                            }

                            attachment_container.append('<br>')

                        });
                        attachment_container.append('<br>')

                        // append clone to wrapper
                        $('.sports-wrapper').append(clone);

                    });

                },
                error: function(err) {

                }

            });
        }
        // Music Notices //
        if ($('.music-wrapper').length > 0) {
            $.ajax({

                url: "https://eduapp.com.au/api/v3/notices.jsonp?api_token=8aa8caeba98f5a6ee9d44c0e4ec6da09950dace3&tag_group_ids[]=120",
                dataType: "jsonp",
                type: "GET",
                success: function(response) {

                    $(".notice-main-title").show();

                    $.each(response, function(index, notice) {

                        // get clone
                        var clone = $('.music-clone').find(":first").clone(true);
                        clone.find('.notices-title').text(notice.title);

                        var body_text = notice.body;
                        body_text = body_text.replace("â€™", "'");

                        clone.find('.notices-body').text(body_text);
                        clone.find('.notices-title').attr('href', '#' + notice.id);
                        clone.find('.notice-content').attr('id', notice.id);

                        // clone.find('.notices-title').click(function() {

                        //     if ($(this).parent().find('.notice-content').css('display') == "block"){
                        //         $(this).parent().find('.notice-content').slideUp();
                        //     } else {
                        //         $(this).parent().find('.notice-content').slideDown();
                        //     }

                        // })

                        var attachment_container = clone.find('.attachments');

                        var attachments = notice.attachments;

                        attachment_container.html('');

                        if (notice.attachments.length > 0) {

                            attachment_container.append('<br><h4>Attachments</h4>');

                        }

                        $.each(attachments, function(index, attachment) {

                            var title = "";

                            if (attachment.type == "link") {

                                title = "Link";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr({href: attachment.url, target: '_blank'}).text(attachment.url);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "file") {
                                
                                title = "File";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr('href', attachment.url).text(attachment.file_name);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "address") {
                                    
                                title = "Address";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<span>').text(attachment.address);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "contact") {
                                
                                title = "Contact";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                            
                                var name = $('<span>').text(attachment.contact_name);
                                var phone = $('<span>').text(attachment.contact_phone);
                                var email = $('<span>').text(attachment.contact_email);

                                attachment_container.append(name);
                                attachment_container.append(phone);
                                attachment_container.append(email);

                            }

                            attachment_container.append('<br>')

                        });
                        attachment_container.append('<br>')

                        // append clone to wrapper
                        $('.music-wrapper').append(clone);

                    });

                },
                error: function(err) {

                }

            });
        }

        // Senior Notices //
        if ($('.senior-wrapper').length > 0) {
            $.ajax({

                url: "https://eduapp.com.au/api/v3/notices.jsonp?api_token=8aa8caeba98f5a6ee9d44c0e4ec6da09950dace3&tag_group_ids[]=104",
                dataType: "jsonp",
                type: "GET",
                success: function(response) {

                    $(".notice-main-title").show();

                    $.each(response, function(index, notice) {

                        // get clone
                        var clone = $('.senior-clone').find(":first").clone(true);
                        clone.find('.notices-title').text(notice.title);

                        var body_text = notice.body;
                        body_text = body_text.replace("â€™", "'");

                        clone.find('.notices-body').text(body_text);
                        clone.find('.notices-title').attr('href', '#' + notice.id);
                        clone.find('.notice-content').attr('id', notice.id);

                        // clone.find('.notices-title').click(function() {

                        //     if ($(this).parent().find('.notice-content').css('display') == "block"){
                        //         $(this).parent().find('.notice-content').slideUp();
                        //     } else {
                        //         $(this).parent().find('.notice-content').slideDown();
                        //     }

                        // })

                        var attachment_container = clone.find('.attachments');

                        var attachments = notice.attachments;

                        attachment_container.html('');

                        if (notice.attachments.length > 0) {

                            attachment_container.append('<br><h4>Attachments</h4>');

                        }

                        $.each(attachments, function(index, attachment) {

                            var title = "";

                            if (attachment.type == "link") {

                                title = "Link";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr({href: attachment.url, target: '_blank'}).text(attachment.url);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "file") {
                                
                                title = "File";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr('href', attachment.url).text(attachment.file_name);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "address") {
                                    
                                title = "Address";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<span>').text(attachment.address);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "contact") {
                                
                                title = "Contact";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                            
                                var name = $('<span>').text(attachment.contact_name);
                                var phone = $('<span>').text(attachment.contact_phone);
                                var email = $('<span>').text(attachment.contact_email);

                                attachment_container.append(name);
                                attachment_container.append(phone);
                                attachment_container.append(email);

                            }

                            attachment_container.append('<br>')

                        });
                        attachment_container.append('<br>')

                        // append clone to wrapper
                        $('.senior-wrapper').append(clone);

                    });

                },
                error: function(err) {

                }

            });
        }
        // junior Notices //
        if ($('.junior-wrapper').length > 0) {
            $.ajax({

                url: "https://eduapp.com.au/api/v3/notices.jsonp?api_token=8aa8caeba98f5a6ee9d44c0e4ec6da09950dace3&tag_group_ids[]=106",
                dataType: "jsonp",
                type: "GET",
                success: function(response) {

                    $(".notice-main-title").show();

                    $.each(response, function(index, notice) {

                        // get clone
                        var clone = $('.junior-clone').find(":first").clone(true);
                        clone.find('.notices-title').text(notice.title);

                        var body_text = notice.body;
                        body_text = body_text.replace("â€™", "'");

                        clone.find('.notices-body').text(body_text);
                        clone.find('.notices-title').attr('href', '#' + notice.id);
                        clone.find('.notice-content').attr('id', notice.id);

                        // clone.find('.notices-title').click(function() {

                        //     if ($(this).parent().find('.notice-content').css('display') == "block"){
                        //         $(this).parent().find('.notice-content').slideUp();
                        //     } else {
                        //         $(this).parent().find('.notice-content').slideDown();
                        //     }

                        // })

                        var attachment_container = clone.find('.attachments');

                        var attachments = notice.attachments;

                        attachment_container.html('');

                        if (notice.attachments.length > 0) {

                            attachment_container.append('<br><h4>Attachments</h4>');

                        }

                        $.each(attachments, function(index, attachment) {

                            var title = "";

                            if (attachment.type == "link") {

                                title = "Link";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr({href: attachment.url, target: '_blank'}).text(attachment.url);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "file") {
                                
                                title = "File";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr('href', attachment.url).text(attachment.file_name);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "address") {
                                    
                                title = "Address";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<span>').text(attachment.address);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "contact") {
                                
                                title = "Contact";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                            
                                var name = $('<span>').text(attachment.contact_name);
                                var phone = $('<span>').text(attachment.contact_phone);
                                var email = $('<span>').text(attachment.contact_email);

                                attachment_container.append(name);
                                attachment_container.append(phone);
                                attachment_container.append(email);

                            }

                            attachment_container.append('<br>')

                        });
                        attachment_container.append('<br>')

                        // append clone to wrapper
                        $('.junior-wrapper').append(clone);

                    });

                },
                error: function(err) {

                }

            });
        }
        // middle Notices //
        if ($('.middle-wrapper').length > 0) {
            $.ajax({

                url: "https://eduapp.com.au/api/v3/notices.jsonp?api_token=8aa8caeba98f5a6ee9d44c0e4ec6da09950dace3&tag_group_ids[]=105",
                dataType: "jsonp",
                type: "GET",
                success: function(response) {

                    $(".notice-main-title").show();

                    $.each(response, function(index, notice) {

                        // get clone
                        var clone = $('.middle-clone').find(":first").clone(true);
                        clone.find('.notices-title').text(notice.title);

                        var body_text = notice.body;
                        body_text = body_text.replace("â€™", "'");

                        clone.find('.notices-body').text(body_text);
                        clone.find('.notices-title').attr('href', '#' + notice.id);
                        clone.find('.notice-content').attr('id', notice.id);

                        // clone.find('.notices-title').click(function() {

                        //     if ($(this).parent().find('.notice-content').css('display') == "block"){
                        //         $(this).parent().find('.notice-content').slideUp();
                        //     } else {
                        //         $(this).parent().find('.notice-content').slideDown();
                        //     }

                        // })

                        var attachment_container = clone.find('.attachments');

                        var attachments = notice.attachments;

                        attachment_container.html('');

                        if (notice.attachments.length > 0) {

                            attachment_container.append('<br><h4>Attachments</h4>');

                        }

                        $.each(attachments, function(index, attachment) {

                            var title = "";

                            if (attachment.type == "link") {

                                title = "Link";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr({href: 'attachment.url', target: '_blank'}).text(attachment.url);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "file") {
                                
                                title = "File";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr('href', attachment.url).text(attachment.file_name);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "address") {
                                    
                                title = "Address";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<span>').text(attachment.address);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "contact") {
                                
                                title = "Contact";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                            
                                var name = $('<span>').text(attachment.contact_name);
                                var phone = $('<span>').text(attachment.contact_phone);
                                var email = $('<span>').text(attachment.contact_email);

                                attachment_container.append(name);
                                attachment_container.append(phone);
                                attachment_container.append(email);

                            }

                            attachment_container.append('<br>')

                        });
                        attachment_container.append('<br>')

                        // append clone to wrapper
                        $('.middle-wrapper').append(clone);

                    });

                },
                error: function(err) {

                }

            });
        }
        // oshc Notices //
        if ($('.oshc-wrapper').length > 0) {
            $.ajax({

                url: "https://eduapp.com.au/api/v3/notices.jsonp?api_token=8aa8caeba98f5a6ee9d44c0e4ec6da09950dace3&tag_group_ids[]=367",
                dataType: "jsonp",
                type: "GET",
                success: function(response) {

                    $(".notice-main-title").show();

                    $.each(response, function(index, notice) {

                        // get clone
                        var clone = $('.oshc-clone').find(":first").clone(true);
                        clone.find('.notices-title').text(notice.title);

                        var body_text = notice.body;
                        body_text = body_text.replace("â€™", "'");

                        clone.find('.notices-body').text(body_text);
                        clone.find('.notices-title').attr('href', '#' + notice.id);
                        clone.find('.notice-content').attr('id', notice.id);

                        // clone.find('.notices-title').click(function() {

                        //     if ($(this).parent().find('.notice-content').css('display') == "block"){
                        //         $(this).parent().find('.notice-content').slideUp();
                        //     } else {
                        //         $(this).parent().find('.notice-content').slideDown();
                        //     }

                        // })

                        var attachment_container = clone.find('.attachments');

                        var attachments = notice.attachments;

                        attachment_container.html('');

                        if (notice.attachments.length > 0) {

                            attachment_container.append('<br><h4>Attachments</h4>');

                        }

                        $.each(attachments, function(index, attachment) {

                            var title = "";

                            if (attachment.type == "link") {

                                title = "Link";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr({href: 'attachment.url', target: '_blank'}).text(attachment.url);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "file") {
                                
                                title = "File";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr('href', attachment.url).text(attachment.file_name);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "address") {
                                    
                                title = "Address";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<span>').text(attachment.address);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "contact") {
                                
                                title = "Contact";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                            
                                var name = $('<span>').text(attachment.contact_name);
                                var phone = $('<span>').text(attachment.contact_phone);
                                var email = $('<span>').text(attachment.contact_email);

                                attachment_container.append(name);
                                attachment_container.append(phone);
                                attachment_container.append(email);

                            }

                            attachment_container.append('<br>')

                        });
                        attachment_container.append('<br>')

                        // append clone to wrapper
                        $('.oshc-wrapper').append(clone);

                    });

                },
                error: function(err) {

                }

            });
        }
        // tuchekoi Notices //
        if ($('.tuchekoi-wrapper').length > 0) {
            $.ajax({

                url: "https://eduapp.com.au/api/v3/notices.jsonp?api_token=8aa8caeba98f5a6ee9d44c0e4ec6da09950dace3&tag_group_ids[]=367",
                dataType: "jsonp",
                type: "GET",
                success: function(response) {

                    $(".notice-main-title").show();

                    $.each(response, function(index, notice) {

                        // get clone
                        var clone = $('.tuchekoi-clone').find(":first").clone(true);
                        clone.find('.notices-title').text(notice.title);

                        var body_text = notice.body;
                        body_text = body_text.replace("â€™", "'");

                        clone.find('.notices-body').text(body_text);
                        clone.find('.notices-title').attr('href', '#' + notice.id);
                        clone.find('.notice-content').attr('id', notice.id);

                        // clone.find('.notices-title').click(function() {

                        //     if ($(this).parent().find('.notice-content').css('display') == "block"){
                        //         $(this).parent().find('.notice-content').slideUp();
                        //     } else {
                        //         $(this).parent().find('.notice-content').slideDown();
                        //     }

                        // })

                        var attachment_container = clone.find('.attachments');

                        var attachments = notice.attachments;

                        attachment_container.html('');

                        if (notice.attachments.length > 0) {

                            attachment_container.append('<br><h4>Attachments</h4>');

                        }

                        $.each(attachments, function(index, attachment) {

                            var title = "";

                            if (attachment.type == "link") {

                                title = "Link";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr({href: 'attachment.url', target: '_blank'}).text(attachment.url);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "file") {
                                
                                title = "File";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<a>').attr('href', attachment.url).text(attachment.file_name);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "address") {
                                    
                                title = "Address";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                                var attach = $('<span>').text(attachment.address);
                                attachment_container.append(attach);

                            }

                            if (attachment.type == "contact") {
                                
                                title = "Contact";
                                attachment_container.append('<strong>' + title + ":</strong> ");
                            
                                var name = $('<span>').text(attachment.contact_name);
                                var phone = $('<span>').text(attachment.contact_phone);
                                var email = $('<span>').text(attachment.contact_email);

                                attachment_container.append(name);
                                attachment_container.append(phone);
                                attachment_container.append(email);

                            }

                            attachment_container.append('<br>')

                        });
                        attachment_container.append('<br>')

                        // append clone to wrapper
                        $('.tuchekoi-wrapper').append(clone);

                    });

                },
                error: function(err) {

                }

            });
        }
